'use strict';
const angular = require('angular');

export class contactFormComponent {
  /*@ngInject*/
  constructor(MailsService, dialogs) {
    this.MailsService = MailsService;
    this.dialogs = dialogs;

    this.typesOfAssociation = ["Condominium", "HOA", "Commercial", "Other"];
    this.managementTypes = ["Management Company", "Self-Managed"]
  }
  
  $onInit() {
    this.buttonLabel = this.btnLabel || 'Submit';
  }

  submitContactForm() {

    let msg = this.message;

    if (this.management) {
      msg += "<br/><br/>---<br/>Additional Information<br/><br/>";

      if (this.nameOfAssociation) {
        msg += "<b>Name  of Association</b>: " + this.nameOfAssociation + "<br/>";
      }

      if (this.relationshipToAssociation) {
        msg += "<b>Relationship to Association</b>: " + this.relationshipToAssociation + "<br/>";
      }

      if (this.typeOfAssociation) {
        msg += "<b>Type of Association</b>: " + this.typeOfAssociation + "<br/>";
      }

      if (this.numberOfUnits) {
        msg += "<b>Number of Units / Buildings</b>: " + this.numberOfUnits + "<br/>";
      }

      if (this.currentManagement) {
        msg += "<b>Current Management</b>: " + this.currentManagement + "<br/>";
      }
    }

    this.MailsService.contact({
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      phone: this.phone,
      address: this.address,
      message: msg
    }, () => {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.phone = '';
      this.message = '';
      this.address = '';
      if (this.management) {
        this.nameOfAssociation = '';
        this.relationshipToAssociation = '';
        this.typeOfAssociation = '';
        this.numberOfUnits = '';
        this.currentManagement = '';
      }

      this.dialogs.notify("Your message has been sent","Your message has been sent.<br/>Thank you for contacting us!");
    });
  }
}

export default angular.module('conduuApp.contactForm', [])
  .component('contactForm', {
    template: require('./contact-form.component.html'),
    bindings: {
      addressRequired: '@',
      columns: '@',
      btnLabel: '@',
      management: '@'
    },
    controller: contactFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/contact-form/contact-form.component.js